module.exports = __webpack_public_path__ + "img/whiteboard_on.84084b99.png";